export default __webpack_public_path__ + "static/media/favicon-dialogue-africa-tanzania-kenya-pb.db9d0840.png";